import { Component, ChangeDetectionStrategy, Type } from '@angular/core';
import { FieldTypeConfig, FormlyFieldConfig, FieldType } from '@ngx-formly/core';
import { BaseFormlyFieldProps } from '../form-field/public_api';

interface TabsProps extends BaseFormlyFieldProps {
    image?: string;
}

export interface FormlyTabsFieldConfig extends FormlyFieldConfig<TabsProps> {
    type: 'kendo-tabs' | Type<FormlyFieldTabs>;
}

@Component({
    selector: 'formly-field-kendo-tabs',
    template: `
        <kendo-tabstrip>
            <kendo-tabstrip-tab *ngFor="let tab of field.fieldGroup; let i = index;" [selected]="i === selected">
                <ng-template kendoTabTitle>
                    <img class="tab-image" [src]="tab.props?.image" />
                    <span>{{ tab.props?.label }}</span>
                </ng-template>
                <ng-template kendoTabContent>
                    <formly-field [field]="tab"></formly-field>
                </ng-template>
            </kendo-tabstrip-tab>
        </kendo-tabstrip>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldTabs extends FieldType<FieldTypeConfig<TabsProps>> {
    selected = 0;
}
